import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { BASE_URL } from '@env';
import constantsStorage from 'constants/Storage';

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const userData = await AsyncStorage.getItem(constantsStorage.authData);
    const headers = config.headers;

    if (userData && headers) {
      const parsedUserData = JSON.parse(userData);
      headers.Authorization = parsedUserData.token ? `Bearer ${parsedUserData.token}` : '';
    }
    if (headers) {
      headers['Cache-Control'] = 'no-cache';
      headers['Pragma'] = 'no-cache';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (error) => {
    const authFailed = [403].includes(error?.response?.status);
    if (authFailed) {
      await AsyncStorage.removeItem(constantsStorage.authData);
      // TODO: Navigate
    } else {
      return Promise.reject(error);
    }
  },
);

export default axiosInstance;
